<template>
  <div class="file-picker-wrapper">
    <h1 class="no-file-selected" v-if="!isAllowedToAddFile && !selectedFile">
      No File Selected
    </h1>
    <div v-show="isAllowedToAddFile && !value">
      <input
        type="file"
        ref="file"
        v-show="false"
        :accept="accpetedFileTypes"
        @change="onFileSelect($event)"
        :style="aiInlineCss"
        @keydown.prevent
      />
      <input
        @drop.prevent="handleFileDrop"
        @dragover.prevent
        @dragenter.prevent="toggleDragging(true)"
        @dragleave.prevent="toggleDragging(false)"
        type="button"
        class="file-selected"
        @click="$refs.file.click()"
        value="+"
        :class="{ 'active-drop-zone': isDragging }"
      />
    </div>
    <div class="dropped-file-wrap" v-if="value">
      <div class="dropped-file-name">
        <div class="dropped-file-content">
          <div class="name">
            <span> {{ value.name }} </span>
            <!-- <span> {{ fileName }}</span> -->
          </div>
          <div class="file-picker-icons" v-if="isActionsButtonEnable">
            <ul>
              <li v-if="!isAddOnly">
                <CustomTooltip
                  :targetId="`${uniqueId}-file-edit`"
                  placement="bottom"
                  tooltipText="Bearbeiten"
                  iconSlotName="edit"
                >
                  <template v-slot:edit>
                    <i
                      class="fa fa-edit"
                      @click="onEditFileButtonClick()"
                      :id="`${uniqueId}-file-edit`"
                    ></i>
                  </template>
                </CustomTooltip>
              </li>
              <!-- Remove false once APi is ready -->
              <li v-if="isDownloadButtonVisible">
                <CustomTooltip
                  :targetId="`${uniqueId}-file-download`"
                  placement="bottom"
                  tooltipText="Exportieren"
                  iconSlotName="download"
                >
                  <template v-slot:download>
                    <b-spinner
                      v-if="loadingStates.download"
                      label="Spinning"
                      small
                      style="width: 16px; height: 16px; color: #000"
                    ></b-spinner>
                    <i
                      v-else
                      :id="`${uniqueId}-file-download`"
                      class="fa fa-download"
                      @click="onDownloadFileButtonClick()"
                    ></i>
                  </template>
                </CustomTooltip>
              </li>
              <li v-if="!hideDeleteIcon && !isAddOnly">
                <CustomTooltip
                  :targetId="`${uniqueId}-file-delete`"
                  placement="bottom"
                  tooltipText="Löschen"
                  iconSlotName="delete"
                >
                  <template v-slot:delete>
                    <i
                      class="fa fa-trash"
                      @click.stop="onCancelFileDelete"
                      :id="`${uniqueId}-file-delete`"
                    ></i>
                  </template>
                </CustomTooltip>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <CommonModal
        v-if="isDeleteFile"
        header="confirm-message"
        :buttons="confirmationBtn"
        :closeIconVisible="true"
        @onConfirmFileDelete="onConfirmFileDelete"
        @onCancelFileDelete="onCancelFileDelete"
        @close="onCancelFileDelete"
        ><template v-slot:confirm-message>
          <p class="confirm-message">
            Sind Sie sicher, dass Sie diese Datei löschen möchten?
          </p>
        </template>
      </CommonModal>
    </div>
  </div>
</template>
<script>
import { downloadFile } from '../../services/customdb.service';
import { saveAs } from 'file-saver';
import CustomTooltip from '../CustomTooltip.vue';
import CommonModal from '../modals/CommonModal.vue';

export default {
  data() {
    return {
      selectedFile: null,
      isDeleteFile: false,
      confirmationBtn: [
        {
          text: 'Bestätigen',
          action: 'onConfirmFileDelete',
          loading: false,
        },
        {
          text: 'Abbrechen',
          action: 'onCancelFileDelete',
          loading: false,
        },
      ],
      isDragging: false,
      loadingStates: {
        download: false,
      },
    };
  },
  props: {
    aiInlineCss: {
      type: String,
      required: false,
      default: '',
    },
    isAllowedToAddFile: {
      type: Boolean,
      default: true,
    },
    isActionsButtonEnable: {
      type: Boolean,
      default: true,
    },
    accpetedFileTypes: {
      type: String,
      default: '*',
    },
    isAddOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    isDownloadButtonVisible: {
      type: Boolean,
      require: false,
      default: false,
    },
    selectedDatabase: {
      type: Object,
      require: false,
      default: () => {},
    },
    hideDeleteIcon: {
      type: Boolean,
      require: false,
      default: false,
    },
    uniqueId: {
      required: false,
      default: '',
    },
  },
  methods: {
    onFileSelect(event) {
      if (!event.target.files[0]) return;
      this.selectedFile = event.target.files[0];
      this.$emit('onFileSelected', event.target.files[0]);
    },
    onConfirmFileDelete(event, canEmit = true) {
      this.selectedFile = null;
      this.$refs.file.value = '';
      if (canEmit) this.$emit('onFileDelete');
      this.isDeleteFile = false;
    },

    setFile(file) {
      this.selectedFile = file;
    },
    onEditFileButtonClick() {
      this.$refs.file.click();
    },
    async onDownloadFileButtonClick() {
      //TODO handle download file here once API is ready
      try {
        this.loadingStates.download = true;

        // Dummy API call
        const response = await downloadFile(
          this.selectedDatabase.name,
          encodeURIComponent(this.selectedFile.link)
        );

        // Create blob
        const contentType = response.headers['content-type'];
        const blob = new Blob([response.data], { type: contentType });

        // Use FileSaver.js to trigger the download
        await saveAs(blob, this.selectedFile.name);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('File-export:', error);
      } finally {
        this.loadingStates.download = false;
      }
    },
    onCancelFileDelete() {
      const parentWrapper = this?.$el?.closest(
        '.form-builder-element-attributes'
      );
      if (parentWrapper) {
        if (!this.isDeleteFile) {
          parentWrapper.style.zIndex = '2';
        } else {
          parentWrapper.style.zIndex = '';
        }
      }
      setTimeout(() => {
        this.isDeleteFile = !this.isDeleteFile;
      }, 150);
    },
    handleFileDrop(event) {
      const file = event.dataTransfer.files[0];
      this.selectedFile = file;
      this.isDragging = false;
      this.$emit('onFileSelected', file);
    },
    toggleDragging(isDragging = false) {
      this.isDragging = isDragging;
    },
  },
  mounted() {
    if (this.value && this.value.name) this.selectedFile = this.value;
  },
  components: {
    CustomTooltip,
    CommonModal,
  },
};
</script>
<style scoped>
.no-file-selected {
  font-size: 20px;
  border: 1px solid #dee3e9;
  box-sizing: border-box;
  padding: 16px 0;
  width: 100%;
  margin: 0;
  border-radius: 2px;
}
.file-selected {
  background-color: #cccccc;
  border: 1px solid #cccccc;
  color: #fff;
  font-size: 40px;
  padding: 10px;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: block;
  height: auto;
  cursor: pointer;
  line-height: 20px;
}

.dropped-file-wrap {
  box-sizing: border-box;
  display: flex;
  margin: 0 0; /*For New editMode UI*/
  flex-wrap: wrap;
}

.dropped-file-wrap .dropped-file-name {
  width: 100%;
  -webkit-box-shadow: 1px 0 5px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 0 5px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border-radius: 4px;
  margin: 0 0px;
  padding: 10px 10px;
  box-sizing: border-box;
}
.no-file-selected {
  position: relative;
  text-align: center;
  width: 100%;
  font-size: 16px;
  color: #464d5d;
  padding: 7px 0;
}

.dropped-file-content {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropped-file-content ul {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.dropped-file-content ul li {
  margin-left: 8px;
}
.dropped-file-content .name {
  font-size: 13px;
  color: #464d5d;
}
.file-picker-icons i {
  cursor: pointer;
}

.file-picker-wrapper .active-drop-zone {
  background-color: #c7d6e3;
  border: 1px solid #c7d6e3;
}
</style>
